// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingPackageGroupPriceResponse

import { BillingPackageName } from './enums.gen';
import { hydrateBillingPackagePrice, type BillingPackagePrice, type BillingPackagePriceApiResponse } from './billingPackagePrice.gen';

export type BillingPackageGroupPriceApiResponse = {
	name: BillingPackageName;
	prices: BillingPackagePriceApiResponse[];
};

export type BillingPackageGroupPrice = {
	name: BillingPackageName;
	prices: BillingPackagePrice[];
};

export function hydrateBillingPackageGroupPrice(data: BillingPackageGroupPriceApiResponse): BillingPackageGroupPrice {
	return {
		...data,
		prices: data.prices.map(hydrateBillingPackagePrice),
	};
}